import type { FC } from "react";

import { TranslationHtmlWrapper } from "@ui/components/TranslationHtmlWrapper/TranslationHtmlWrapper";
import { useAuthHrefResolver } from "@ui/providers/AuthRoutingProvider";
import { useTranslations } from "@ui/providers/useTranslations";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { AUTH_ROUTE_PATHS } from "@jti/fe-common/routes/auth-routes";

export const ExistingAccount: FC = () => {
  const { __ } = useTranslations();
  const resolveAuthHref = useAuthHrefResolver();
  const loginHref = resolveAuthHref({ route: AUTH_ROUTE_PATHS.login });
  const resetPasswordHref = resolveAuthHref({ route: AUTH_ROUTE_PATHS.resetPassword });

  return (
    <AlertBanner
      tone="info"
      title={__("existing_account.title")}
      richDescription={
        <TranslationHtmlWrapper text="existing_account.text" htmlData={[loginHref, resetPasswordHref]} />
      }
    />
  );
};
